import { createFileRoute } from "@tanstack/react-router";
import Page from "./-share_pages/upload";
export const Route = createFileRoute("/template_protections/upload")({
  component: Page,
});
